/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

import { makeStyles } from '@griffel/react';

/**
 * Styles for the Footer slots
 */
export const useFooterStyles = makeStyles({
  root: {
    height: '48px'
  },
  socialLink: {
    display: 'inline-block',
    lineHeigh: '1.5',
    color: 'inherit'
  }
});
